/* Chat launcher placement on phones — the ONE place that moves or hides the chat bubble.

   The chat (Gorgias) is not part of the theme: a legacy Shopify ScriptTag injects
   `body > iframe[title="Chat"]` (or #gorgias-chat-container) after window load and rewrites
   its inline style when it opens/closes. On phones its closed bubble (~108px) sat on top of
   the size dropdown, the right edge of the sticky buy bar and rows in the cart drawer.

   Rules (phones only, max-width: 767px; desktop is never touched):
   1. Hidden while any drawer or modal is open (cart drawer, search sheet, menu, filters,
      frame popup): the theme marks that with body.overflow-hidden / .drawer.is-open.
   2. Hidden while the product page's size / frame / Add to cart controls are on screen.
   3. Otherwise lifted to sit just above a visible sticky bottom bar (product-buy-bar).
   Only the closed bubble is touched; an open chat window is always left alone.

   Other scripts must not move the bubble themselves: call window.PeletonChatLauncher.update()
   after changing layout (assets/mobile-pdp.js defers to this file when it is present). */
(function () {
  'use strict';
  if (window.PeletonChatLauncher) return;

  var CHAT_SEL = 'body > iframe[title="Chat"], #gorgias-chat-container';
  var BUBBLE_MAX = 160; // px: taller than this is the open chat window, not the bubble
  var HIDDEN = 'chat-launcher-hidden';
  var CONTROLS_SEL = [
    '.pdp-content .product-block__variant_picker',
    '.pdp-content .product-block__frame_selector',
    '.pdp-content .product-block__buy_buttons'
  ].join(',');
  var BARS_SEL = 'product-buy-bar'; // fixed bottom bars the bubble must clear
  var phone = window.matchMedia('(max-width: 767px)');
  var ticking = false;

  var style = document.createElement('style');
  style.textContent =
    '.' + HIDDEN + '{opacity:0!important;visibility:hidden!important;pointer-events:none!important;' +
    'transition:opacity .2s ease,visibility 0s linear .2s!important}';
  document.head.appendChild(style);

  function $$(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  function overlayOpen() {
    return document.body.classList.contains('overflow-hidden') || !!document.querySelector('.drawer.is-open, .modal.is-open');
  }

  function barLift() {
    var lift = 0;
    $$(BARS_SEL).forEach(function (bar) {
      var el = bar.querySelector('.product-buy-bar') || bar;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      // Resting height, not the animated position: the theme slides the bar in over 0.3s
      // and the bubble must already clear it when it lands.
      var shown = el.classList.contains('show') || document.documentElement.getAttribute('data-mobile-pdp') === 'sticky';
      if (shown) lift = Math.max(lift, el.offsetHeight);
    });
    return lift;
  }

  function controlsInView(limit) {
    return $$(CONTROLS_SEL).some(function (el) {
      var r = el.getBoundingClientRect();
      return r.height > 0 && r.bottom > 0 && r.top < limit;
    });
  }

  function reset(el) {
    el.classList.remove(HIDDEN);
    if (el.style.getPropertyPriority('bottom') === 'important') el.style.removeProperty('bottom');
  }

  function update() {
    ticking = false;
    var els = $$(CHAT_SEL);
    if (!els.length) return;
    if (!phone.matches) { els.forEach(reset); return; }
    var lift = barLift();
    var hide = overlayOpen() || controlsInView(window.innerHeight - lift);
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var isBubble = r.height > 0 && r.height <= BUBBLE_MAX;
      // visibility:hidden keeps the box, so a hidden bubble still measures as a bubble;
      // anything taller is the open chat window and is never hidden or moved.
      if (!isBubble) { reset(el); return; }
      var want = lift + 'px';
      if (lift > 0) {
        if (el.style.getPropertyValue('bottom') !== want || el.style.getPropertyPriority('bottom') !== 'important') {
          el.style.setProperty('bottom', want, 'important');
        }
      } else if (el.style.getPropertyPriority('bottom') === 'important') {
        el.style.removeProperty('bottom');
      }
      el.classList.toggle(HIDDEN, hide);
    });
  }

  function request() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }

  window.PeletonChatLauncher = { update: request };

  function init() {
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    if (phone.addEventListener) phone.addEventListener('change', request);
    // The chat script injects its iframe late; drawers/modals toggle classes on body and on
    // themselves; the buy bar toggles .show.
    new MutationObserver(request).observe(document.body, { childList: true, attributes: true, attributeFilter: ['class'] });
    var seen = new WeakSet();
    function watch() {
      $$(CHAT_SEL + ',.drawer,.modal,' + BARS_SEL + ',' + BARS_SEL + ' .product-buy-bar').forEach(function (el) {
        if (seen.has(el)) return;
        seen.add(el);
        new MutationObserver(request).observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
        request();
      });
    }
    watch();
    setInterval(watch, 1000);
    request();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
